module.exports = __webpack_public_path__ + "static/media/choose_us_5_selected.4dc8e093.png";